module.exports = __webpack_public_path__ + "static/media/EB.9140d007.png";